export enum RouterPath {
  CustomerTermsAndConditions = "/customer-terms-and-conditions",
  Dashboard = "/dashboard",
  Home = "/",
  Login = "/login",
  LoggedOut = "/logged-out",
  LoginTokenExpired = "/token-expired",
  LoginLinkSent = "/login-link-sent",
  LoginHelp = "/login-help",
  VerifyLink = "/verify-link",
  Questionnaires = "/questionnaires/:initialTab",
  QuestionnaireAnswers = "/questionnaire-answers",
  QuestionnaireTemplate = "/questionnaire-template",
  SendQuestionnaire = "/send-questionnaire",
  Team = "/team",
  SuppliersRegistry = "/suppliers-registry",
  CreateQuestionnaire = "/create-questionnaire",
  EditQuestionnaire = "/edit-questionnaire",
  ManageUserProfile = "/manage-user-profile",
  DetailedRiskCategory = "/detailed-risk-category",
  UnitProfile = "/unit-profile",
  ReceivedQuestionnaireStatus = "/received-questionnaire-status",
  MyQuestionnaireStatus = "/my-questionnaire-status",
  UploadSuppliers = "/upload-suppliers",

  // Fill Out Questionnaire Routes
  StartQuestionnaire = "/questionnaire/start",
  Questionnaire = "/questionnaire/answer",
  UploadSuppliersForQuestionnaire = "/questionnaire/upload-suppliers",
  ForwardQuestionnaire = "/questionnaire/forward",
  ReuseAnswers = "/questionnaire/reuse-answers",

  //Admin Routes
  AdministratorPage = "/admin",
  AdminCreateUserPage = "/admin/create-user",
  AdminViewUserPage = "/admin/view-user",
  AdminViewTrustGroupPage = "/admin/view-trust-group",
  AdminListLockedUsersPage = "/admin/locked-users",
  AdminListUsersPage = "/admin/list-users",
  AdminCreateCustomer = "/admin/create-customer",
  AdminRecalculateStatsPage = "/admin/recalculate-stats",
  AdminCustomersOverview = "/admin/customers-overview",

  // New Supplier Routes
  RegisterSupplierWelcome = "/register-supplier/welcome",
  RegisterSupplierCompany = "/register-supplier/company",
  AddColleaguesView = "/register-supplier/invite-users",

  //Super User Routes
  SuperUserWelcome = "/superuser/welcome",

  // Help routes
  Help = "/help",
  AboutTheAct = "/help/the-act",
  AboutTransparencyChain = "/help/about",
}
